import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, Subscription } from 'rxjs';
import { ProgramBrandModel } from '../model/appointment.model';

@Component({
  selector: 'app-testimonial',
  templateUrl: './testimonial.component.html',
  styleUrls: ['./testimonial.component.css', '../appointment/appointment.component.css']
})
export class TestimonialComponent implements OnInit {
  @Input() brand: ProgramBrandModel;
  @Input() french: boolean;
  @Input() events: Observable<void>;
  private brandSubscription: Subscription;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    if (this.events) {
      this.brandSubscription = this.events.subscribe(() => {
        this.onRefresh();
      });
    }
    this.onRefresh();
  }

  ngOnDestroy() {
    if (this.brandSubscription) {
      this.brandSubscription.unsubscribe();
    }
  }

  onRefresh() {
    if (this.brand) {
      var video = this.brand.testimonial.video;
      setTimeout(function () {
        var iframes = document.getElementsByClassName('testimonial-video-video');
        for (var i = 0; i < iframes.length; i++) {
          var iframe = iframes[i] as HTMLIFrameElement;
          iframe.src = video;
        }
      }, 500);
    }
  }

  singleQuote() {
    return this.brand && this.brand.testimonial && this.brand.testimonial.items && this.brand.testimonial && this.brand.testimonial.items.length == 1;
  }

  doubleQuote() {
    return this.brand && this.brand.testimonial && this.brand.testimonial.items && this.brand.testimonial && this.brand.testimonial.items.length > 1;
  }

  safe(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
